app.controller("EditAdminController", ["$scope", "$uibModalInstance", "Users", "Administrators", "StaticData", "ProgramService", "admin", "toastr",
    function ($scope, $uibModalInstance, Users, Administrators, StaticData, ProgramService, admin, toastr) {
        $scope.chosenFaculties = {};
        admin.info.faculties.forEach(function (faculty) {
            $scope.chosenFaculties[faculty] = true;
        });

        StaticData.getItemsByKey("faculties").then(function (faculties) {
            $scope.faculties = faculties;
            $scope.facultiesMap = _.keyBy($scope.faculties, '_id');
        });

        $scope.edit = function () {
            admin = admin || {};
            admin.info = admin.info || {};
            admin.info.faculties = _($scope.chosenFaculties).pickBy(function (value) {
                return value;
            }).keys().value();
            Administrators.edit(admin).then(function () {
                $uibModalInstance.close();
            }).catch(function (err) {
                if (err.status == 400) {
                    toastr.error('', 'მიმდინარე მომხმარებელს უკვე აქვს ადმინისტრატორის აქტიური პროფილი.');
                }
            });
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);